import React from 'react';
import TableColumnTitle from '../../../../components/_table/TableColumnTitle';
import TableFilterInput from '../../../../components/_table/TableFilterInput';
import OpenUserDetail from '../../../../components/link/OpenUserDetail';
import { setDash, setPhoneFormat } from '../../../../lib/common';
import { setDateFormat } from '../../../../lib/moment';
import { DATE_FORMAT } from '../../../../constants/service/common/utilConstants';

/**
 *  쿠폰 미사용 내역 리스트 컬럼
 */
export const columns = (data) => {
  const { isFilter, filterOption, onFilter } = data;

  return [
    {
      title: <TableColumnTitle title={'쿠폰 발급 ID'} />,
      dataIndex: 'couponGeneratedId',
    },
    {
      title: <TableColumnTitle title={'유저 ID'} />,
      dataIndex: 'userId',
      render: (value) => <OpenUserDetail text={value} userId={value} />,
    },
    {
      title: <TableColumnTitle title={'이름'} filterValue={filterOption.userName} />,
      dataIndex: 'userName',
      className: !isFilter && 'not-filter',
      filterDropdown: ({ confirm }) => (
        <TableFilterInput
          placeholder={'이름 검색'}
          option={filterOption.userName}
          confirm={confirm}
          onFilter={(userName) => onFilter({ userName })}
        />
      ),
      render: (value) => setDash(value),
    },
    {
      title: <TableColumnTitle title={'아이디'} filterValue={filterOption.userAccount} />,
      dataIndex: 'userAccount',
      className: !isFilter && 'not-filter',
      filterDropdown: ({ confirm }) => (
        <TableFilterInput
          placeholder={'아이디 검색'}
          option={filterOption.userAccount}
          confirm={confirm}
          onFilter={(userAccount) => onFilter({ userAccount })}
        />
      ),
      render: (value, record) => <OpenUserDetail text={value} userId={record.id} />,
    },
    {
      title: <TableColumnTitle title={'휴대폰번호'} />,
      dataIndex: 'userCellPhone',
      render: (value, record) => <OpenUserDetail text={setPhoneFormat(value)} userId={record.userId} />,
    },
    {
      title: <TableColumnTitle title={'발급일자'} />,
      dataIndex: 'createDate',
      render: (value) => setDateFormat(value, DATE_FORMAT.FULL_DASH_FORMAT),
    },
    {
      title: <TableColumnTitle title={'만료일'} />,
      dataIndex: 'endDate',
      render: (value) => setDateFormat(value, DATE_FORMAT.FULL_DASH_FORMAT),
    },
  ];
};
